import axios from 'axios';
import {
    useEffect
} from 'react';
import {
    useState
} from 'react';
import {
    useNavigate
} from 'react-router-dom';
import {
    GROLOG_URL
} from '../../../../constant/apiConstant';
import {
    ROUTES
} from '../../../../constant/routeConstant';
import {
    validUOM
} from '../validation-uom';
import {
    t
} from 'i18next';
import {
    validateSubmit
} from '../../../../util';
import { REGEX_CONSTANT } from '../../../../constant/regexConstant';
import { useDispatch, useSelector } from "react-redux";
import { onChanged } from '../../../../util/Util';

const useAddUOM = () => {
    const { token, client_id, grolog_account_id, userId } = useSelector((state) => state.auth);
    let param = `CLIENT_ID=${client_id}&RESOURCE_USER_ID=${userId}&GROLOG_ACCOUNT_ID=${grolog_account_id}`;
    const api = GROLOG_URL;
    const navigate = useNavigate();
    const [successModalOpen, setSuccessModalOpen] = useState(false);
    const [failedModalOpen, setFailedModalOpen] = useState(false);
    const [messageFailed, setMessageFailed] = useState('');

    const [loading, setLoading] = useState(true);
    const [visible, setVisible] = useState(false);
    const [listCategory, setListCategory] = useState([]);
    const [form, setForm] = useState({});
    const [error, setError] = useState([]);
    const [err, setErr] = useState("");

    const [showConfirm, setShowConfirm] = useState(false)
    const [isChanged, setIsChanged] = useState(false)
    const dispatch = useDispatch()

    const optionsCategory = [{
        label: 'Length',
        value: 'L'
    },
    {
        label: 'Weight',
        value: 'W'
    },
    {
        label: 'Volume',
        value: 'V'
    },
    {
        label: 'Temperature',
        value: 'T'
    },
    ];

    const backToList = () => {
        if (!isChanged) {
            navigate(ROUTES.UOM.LIST)
          } else{
            setShowConfirm(true)
          }
    }


    useEffect(() => {
        setListCategory(optionsCategory);
    }, []);

    const _onAdd = () => {
        let errors = {};
        let converseTion = form?.uom_conversions_to && !form?.uom_conversions_to.includes(",") ? form?.uom_conversions_to : form?.uom_conversions_to && form?.uom_conversions_to.includes(",") ? form?.uom_conversions_to?.replace(/,/g, ".") : 0;
        let data = {...form, uom_conversions_to: Number(converseTion) };

        const keys = {
            uom_category: form.uom_category,
            uom_name: form.uom_name,
            uom_category_code: form.uom_category_code,
            uom_conversions_to: form.uom_conversions_to,
            uom_description: form.uom_description,
        }

        for (const key in keys) {
            const option = validUOM(key, keys[key], t);
            const currentError = option;
            errors = {
                ...currentError,
                ...errors
            };
        }
        setError(errors);
        if (validateSubmit(errors)) {
            const headers = {
                "Authorization": token
            };

            axios.post(`${api}/uom?${param}`, data, {
                headers
            })
                .then(response => {
                    if (response.status === 200) {
                        setSuccessModalOpen(true)
                    }
                }).catch((error) => {
                    const errorCode = error.response.status;

                    if (errorCode === 400) {
                        const errorMessage = error.response.data.payload.message;

                        setMessageFailed(errorMessage);
                        setFailedModalOpen(true);
                    }
                })

        } else {
            setError(errors);
        }
    }

    const _onChange = (evt, namespace) => {
        setErr("")
        onChanged(dispatch, true)
        setIsChanged(true)
        if (namespace === 'uom_category') {
            let eror = validUOM(namespace, evt, t);
            setError({
                ...error,
                ...eror
            });
            setForm((prevsValues) => {
                return {
                    ...prevsValues,
                    [namespace]: evt
                }
            });
        } else if (namespace === 'uom_conversions_to') {
            let eror = validUOM(namespace, evt.target.value, t);
            setError({
                ...error,
                ...eror
            });
            setForm((prevsValues) => {
                return {
                    ...prevsValues,
                    [namespace]: evt.target.value
                }
            });
        } else {
            let eror = validUOM(namespace, evt.target.value, t);
            setError({
                ...error,
                ...eror
            });
            setForm((prevsValues) => {
                return {
                    ...prevsValues,
                    [namespace]: evt.target.value
                }
            });
        }
    }

    const _onOkSuccesAdd = () => {
        setSuccessModalOpen(false)
        navigate(ROUTES.UOM.LIST)
    }

    const handleKeyPress = (event) => {
        const keyCode = event.keyCode || event.which;
        const keyValue = String.fromCharCode(keyCode);

        // Allow only number input
        if (!REGEX_CONSTANT.JUST_NUMBER.test(keyValue)) {
            event.preventDefault();
        }
    };

    return {
        backToList,
        _onAdd,
        visible,
        setVisible,
        _onChange,
        listCategory,
        form,
        err,
        error,
        setErr,
        setError,
        failedModalOpen,
        messageFailed,
        successModalOpen,
        _onOkSuccesAdd,
        setFailedModalOpen,
        handleKeyPress,
        showConfirm,
        setShowConfirm
    }
}

export default useAddUOM;